


import Vue from "vue";
import GuciI18n from "vue-i18n";
Vue.use(GuciI18n);

import { zh } from "../i18n/zh";
import { en } from "../i18n/en";

export const GuciLan = new GuciI18n({
  locale: localStorage.getItem("locale") || "zh", 
  messages: {
    en:{ en },
    zh:{ zh }
  }
});
 
export default GuciLan;


// WEBPACK FOOTER //
// ./src/utils/GuciI18n.js